<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange" @row-click="selectCurrentRow">

					<el-table-column type="selection"> </el-table-column>

					<el-table-column prop="Title" label="标题" width></el-table-column>

					<el-table-column prop="Type" label="类型" width>
						<template slot-scope="scope">
							<el-tag :type="scope.row.Type == 1 ? 'primary' : 'warning'" disable-transitions>
								{{ scope.row.Type == 1 ? '公告' : '新闻' }}
							</el-tag>
						</template>
					</el-table-column>

					<el-table-column prop="IsExternalLink" label="是否外链" width>
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsExternalLink == 1 ? 'success' : 'info'" disable-transitions>
								{{ scope.row.IsExternalLink == 1 ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>

					<el-table-column prop="ExternalLink" label="外链地址" width>
						<template slot-scope="scope">
							<span v-if="scope.row.IsExternalLink">
								<el-tooltip class="item" effect="dark" :content="scope.row.ExternalLink"
									placement="top">
									<a :href="scope.row.ExternalLink" target="_blank"
										style="max-width: 200px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle;"
										:title="scope.row.ExternalLink">
										{{ scope.row.ExternalLink }}
									</a>
								</el-tooltip>
							</span>
							<span v-else>—</span>
						</template>
					</el-table-column>

					<el-table-column prop="IsPublish" label="是否发布" width="">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsPublish == 1 ? 'success' : 'info'" disable-transitions>{{
								scope.row.IsPublish == 1 ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="展示有效期" min-width="180" show-overflow-tooltip>
						<template slot-scope="scope">{{ formatValidity(scope.row) }}</template>
					</el-table-column>
					<el-table-column prop="IsScreenSaver" label="屏保" width="80">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsScreenSaver ? 'success' : 'info'" disable-transitions>
								{{ scope.row.IsScreenSaver ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="IsTop" label="置顶" width="80">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsTop ? 'warning' : 'info'" disable-transitions>
								{{ scope.row.IsTop ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="IsTextScroll" label="文字滚动" width="100">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsTextScroll ? 'primary' : 'info'" disable-transitions>
								{{ scope.row.IsTextScroll ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="IsFullScreen" label="霸屏" width="80">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsFullScreen ? 'danger' : 'info'" disable-transitions>
								{{ scope.row.IsFullScreen ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="PlayDurationSeconds" label="时长(秒)" width="100"></el-table-column>

					<!-- <el-table-column prop="DepartmentName" label="所属机构" width> </el-table-column>
					 -->
					<el-table-column prop="Sort" label="排序" width> </el-table-column>
					<el-table-column prop="CreateBy" label="创建人" width>

					</el-table-column>

					<el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime"
						width></el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!--编辑界面-->
			<el-dialog title="编辑公告" :visible.sync="editFormVisible" v-model="editFormVisible" width="720px"
				:close-on-click-modal="false" custom-class="notice-record-dialog dialog-body-free">
				<el-form :model="editForm" label-width="88px" :rules="editFormRules" ref="editForm" class="notice-form">
					<div class="notice-form-section">
						<div class="notice-form-section__title">基本信息</div>
						<el-form-item label="标题" prop="Title">
							<el-input v-model="editForm.Title" auto-complete="off"></el-input>
						</el-form-item>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="类型" prop="Type">
									<el-radio-group v-model="editForm.Type">
										<el-radio :label="1">公告</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="是否外链" prop="IsExternalLink">
									<el-radio-group v-model="editForm.IsExternalLink">
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="外链地址" prop="ExternalLink" v-if="editForm.IsExternalLink == 1">
							<el-input v-model="editForm.ExternalLink" auto-complete="off" placeholder="请输入完整 URL"></el-input>
						</el-form-item>
					</div>

					<div class="notice-form-section">
						<div class="notice-form-section__title">发布与展示</div>
						<div class="notice-switch-grid">
							<el-form-item label="发布" prop="IsPublish">
								<el-switch v-model="editForm.IsPublish"></el-switch>
							</el-form-item>
							<el-form-item label="屏保">
								<el-switch v-model="editForm.IsScreenSaver"></el-switch>
							</el-form-item>
							<el-form-item label="置顶">
								<el-switch v-model="editForm.IsTop"></el-switch>
							</el-form-item>
							<el-form-item label="文字滚动">
								<el-switch v-model="editForm.IsTextScroll" :disabled="editForm.IsExternalLink == 1"></el-switch>
							</el-form-item>
							<el-form-item label="霸屏">
								<el-switch v-model="editForm.IsFullScreen"></el-switch>
							</el-form-item>
						</div>
						<el-row :gutter="16" class="notice-validity-row">
							<el-col :span="12">
								<el-form-item label="展示开始">
									<el-date-picker v-model="editForm.ValidFrom" type="datetime" clearable
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="不限制"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="展示结束">
									<el-date-picker v-model="editForm.ValidTo" type="datetime" clearable
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="永久有效"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<p class="notice-form-tip">不填开始不限制，不填结束表示永久。过期后班牌不再展示。</p>
						<p v-if="editForm.IsExternalLink == 1" class="notice-form-tip">外链公告不支持文字滚动</p>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="排序" prop="Sort">
									<el-input v-model="editForm.Sort" autocomplete="off" type="number"></el-input>
									<span class="notice-form-tip notice-form-tip--field">数字越小越靠前</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="播放时长" class="notice-form-item--suffix">
									<el-input v-model.number="editForm.PlayDurationSeconds" autocomplete="off" type="number" min="3" max="300"></el-input>
									<span class="notice-form-suffix">秒</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row v-if="editForm.IsFullScreen" :gutter="16" class="notice-fullscreen-row">
							<el-col :span="12">
								<el-form-item label="霸屏开始">
									<el-date-picker v-model="editForm.FullScreenStartTime" type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="霸屏结束">
									<el-date-picker v-model="editForm.FullScreenEndTime" type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
					</div>

					<div class="notice-form-section notice-form-section--editor" v-if="editForm.IsExternalLink != 1">
						<div class="notice-form-section__title">内容</div>
						<el-form-item prop="Content" label-width="0" class="notice-editor-item">
							<el-input v-if="editForm.IsTextScroll" v-model="editForm.Content" type="textarea" :rows="6"
								placeholder="文字滚动模式下请输入纯文本内容"></el-input>
							<quill-editor v-else v-model="editForm.Content" ref="myQuillEditor" :options="editorOption"
								@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
								@change="onEditorChange($event)">
							</quill-editor>
						</el-form-item>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增公告" :visible.sync="addFormVisible" v-model="addFormVisible" width="720px"
				:close-on-click-modal="false" custom-class="notice-record-dialog dialog-body-free">
				<el-form :model="addForm" label-width="88px" :rules="addFormRules" ref="addForm" class="notice-form">
					<div class="notice-form-section">
						<div class="notice-form-section__title">基本信息</div>
						<el-form-item label="标题" prop="Title">
							<el-input v-model="addForm.Title" auto-complete="off"></el-input>
						</el-form-item>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="类型" prop="Type">
									<el-radio-group v-model="addForm.Type">
										<el-radio :label="1">公告</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="是否外链" prop="IsExternalLink">
									<el-radio-group v-model="addForm.IsExternalLink">
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="外链地址" prop="ExternalLink" v-if="addForm.IsExternalLink == 1">
							<el-input v-model="addForm.ExternalLink" auto-complete="off" placeholder="请输入完整 URL"></el-input>
						</el-form-item>
					</div>

					<div class="notice-form-section">
						<div class="notice-form-section__title">发布与展示</div>
						<div class="notice-switch-grid">
							<el-form-item label="发布" prop="IsPublish">
								<el-switch v-model="addForm.IsPublish"></el-switch>
							</el-form-item>
							<el-form-item label="屏保">
								<el-switch v-model="addForm.IsScreenSaver"></el-switch>
							</el-form-item>
							<el-form-item label="置顶">
								<el-switch v-model="addForm.IsTop"></el-switch>
							</el-form-item>
							<el-form-item label="文字滚动">
								<el-switch v-model="addForm.IsTextScroll" :disabled="addForm.IsExternalLink == 1"></el-switch>
							</el-form-item>
							<el-form-item label="霸屏">
								<el-switch v-model="addForm.IsFullScreen"></el-switch>
							</el-form-item>
						</div>
						<el-row :gutter="16" class="notice-validity-row">
							<el-col :span="12">
								<el-form-item label="展示开始">
									<el-date-picker v-model="addForm.ValidFrom" type="datetime" clearable
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="不限制"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="展示结束">
									<el-date-picker v-model="addForm.ValidTo" type="datetime" clearable
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="永久有效"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<p class="notice-form-tip">不填开始不限制，不填结束表示永久。过期后班牌不再展示。</p>
						<p v-if="addForm.IsExternalLink == 1" class="notice-form-tip">外链公告不支持文字滚动</p>
						<el-row :gutter="16">
							<el-col :span="12">
								<el-form-item label="排序" prop="Sort">
									<el-input v-model="addForm.Sort" autocomplete="off" type="number"></el-input>
									<span class="notice-form-tip notice-form-tip--field">数字越小越靠前</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="播放时长" class="notice-form-item--suffix">
									<el-input v-model.number="addForm.PlayDurationSeconds" autocomplete="off" type="number" min="3" max="300"></el-input>
									<span class="notice-form-suffix">秒</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row v-if="addForm.IsFullScreen" :gutter="16" class="notice-fullscreen-row">
							<el-col :span="12">
								<el-form-item label="霸屏开始">
									<el-date-picker v-model="addForm.FullScreenStartTime" type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="霸屏结束">
									<el-date-picker v-model="addForm.FullScreenEndTime" type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间"
										style="width: 100%;"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
					</div>

					<div class="notice-form-section notice-form-section--editor" v-if="addForm.IsExternalLink != 1">
						<div class="notice-form-section__title">内容</div>
						<el-form-item prop="Content" label-width="0" class="notice-editor-item">
							<el-input v-if="addForm.IsTextScroll" v-model="addForm.Content" type="textarea" :rows="6"
								placeholder="文字滚动模式下请输入纯文本内容"></el-input>
							<quill-editor v-else v-model="addForm.Content" ref="myQuillEditor" :options="editorOption"
								@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
								@change="onEditorChange($event)">
							</quill-editor>
						</el-form-item>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<el-upload style="display: none;" name="Files" :data="quillUploadData" class="quill-upload" :on-success="quillSuccess"
				accept=".png, .jpg, .jpeg" :action="BaseApiUrl + '/images/Upload/Pic'">
				<i class="el-icon-upload"></i>
			</el-upload>

		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getNoticeRecordListPage, editNoticeRecord, addNoticeRecord, deleteNoticeRecord } from '../../api/modules/misc';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
import {
	buildLocalPicUploadData,
	normalizeRichTextHtmlForSave,
	prepareRichTextHtmlForDisplay,
	stripOssPresignParams,
} from '../../utils/ossMediaUpload'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			/** 富文本插图本机上传（不传 SchId，班牌可直链） */
			quillUploadData: buildLocalPicUploadData('NoticeRecord'),
			imageUrl: '',
			imageLoadding: false,
			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				Href: '',
				imageUrl: '',
				Title: '',
				Content: '',
				IsPublish: '',
				Sort: '',
				DepartmentId: 0,
				Type: 1,
				IsExternalLink: 0,
				ExternalLink: '',
				IsScreenSaver: false,
				IsTop: false,
				IsTextScroll: false,
				IsFullScreen: false,
				FullScreenStartTime: '',
				FullScreenEndTime: '',
				FullScreenExpireTime: '',
				PlayDurationSeconds: 15,
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
			},
			//新增界面数据
			addForm: {
				Title: '',
				Href: '',
				imageUrl: '',
				Content: '',
				IsTop: '',
				IsPublish: '',
				Sort: 1,
				DepartmentId: 0,
				Type: 1,
				IsExternalLink: 0,
				ExternalLink: '',
				IsScreenSaver: false,
				IsTop: false,
				IsTextScroll: false,
				IsFullScreen: false,
				FullScreenStartTime: '',
				FullScreenEndTime: '',
				FullScreenExpireTime: '',
				PlayDurationSeconds: 15,
			},
			DepartmentId: 0,
			multipleSelection: [],
		}
	},
	methods: {
		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm:ss')
		},
		formatValidity(row) {
			const from = row.ValidFrom || row.validFrom
			const to = row.ValidTo || row.validTo
			if (!from && !to) return '永久'
			const fmt = (v) => util.formatDate.format(new Date(v), 'yyyy-MM-dd hh:mm')
			if (from && to) return fmt(from) + ' ~ ' + fmt(to)
			if (from) return fmt(from) + ' 起'
			return '至 ' + fmt(to)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				departmentId: this.DepartmentId,
				type: 1, //公告
			}
			getNoticeRecordListPage(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
				type: 1, //公告
			}
			this.listLoading = true

			//NProgress.start();
			getNoticeRecordListPage(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.users = res.data.response.data
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//显示编辑界面
		handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			this.editFormVisible = true
			this.editForm = Object.assign({}, row[0])
			this.normalizeNoticeConfig(this.editForm)
			if (this.editForm.Content) {
				this.editForm.Content = prepareRichTextHtmlForDisplay(this.editForm.Content, this.BaseApiUrl)
			}
			this.imageUrl = this.editForm.imageUrl
		},
		//显示新增界面
		handleAdd() {
			if (!this.DepartmentId || this.DepartmentId === 0) {
				this.$message({
					message: "请先选择左侧所属机构！",
					type: "warning",
				});
				return;
			}
			this.addFormVisible = true
			this.addForm = {
				Title: '',
				Href: '',
				Content: '',
				IsTop: false,
				IsPublish: true,
				Sort: 1,
				DepartmentId: this.DepartmentId,
				Type: 1,
				IsExternalLink: 0,
				ExternalLink: '',
				IsScreenSaver: false,
				IsTextScroll: false,
				IsFullScreen: false,
				FullScreenStartTime: '',
				FullScreenEndTime: '',
				FullScreenExpireTime: '',
				PlayDurationSeconds: 15,
			}
			this.imageUrl = ''
		},
		normalizeNoticeConfig(form) {
			if (!form) {
				return
			}
			form.IsScreenSaver = !!form.IsScreenSaver
			form.IsTop = !!form.IsTop
			form.IsTextScroll = !!form.IsTextScroll
			form.IsFullScreen = !!form.IsFullScreen
			form.FullScreenStartTime = form.FullScreenStartTime || ''
			form.FullScreenEndTime = form.FullScreenEndTime || ''
			if (!form.PlayDurationSeconds || Number(form.PlayDurationSeconds) <= 0) {
				form.PlayDurationSeconds = 15
			} else {
				form.PlayDurationSeconds = Number(form.PlayDurationSeconds)
			}
			if (!form.IsFullScreen) {
				form.FullScreenStartTime = ''
				form.FullScreenEndTime = ''
				form.FullScreenExpireTime = ''
			}
		},
		validateNoticeConfig(form) {
			if (form.IsExternalLink == 1) {
				form.IsTextScroll = false
				form.Content = ''
			}
			if (!form.PlayDurationSeconds || Number(form.PlayDurationSeconds) <= 0) {
				form.PlayDurationSeconds = 15
			}
			if (Number(form.PlayDurationSeconds) < 3 || Number(form.PlayDurationSeconds) > 300) {
				this.$message.error('播放时长请设置在 3 到 300 秒之间')
				return false
			}
			if (form.IsFullScreen && (!form.FullScreenStartTime || !form.FullScreenEndTime)) {
				this.$message.error('开启霸屏后请设置霸屏开始时间和结束时间')
				return false
			}
			if (form.IsFullScreen && new Date(form.FullScreenStartTime).getTime() >= new Date(form.FullScreenEndTime).getTime()) {
				this.$message.error('霸屏结束时间必须晚于开始时间')
				return false
			}
			if (!form.IsFullScreen) {
				form.FullScreenStartTime = ''
				form.FullScreenEndTime = ''
				form.FullScreenExpireTime = ''
			} else {
				form.FullScreenExpireTime = form.FullScreenEndTime
			}
			if (form.IsTextScroll) {
				form.Content = this.toPlainText(form.Content)
			}
			return true
		},
		toPlainText(html) {
			if (!html) {
				return ''
			}
			const container = document.createElement('div')
			container.innerHTML = html
			return (container.textContent || container.innerText || '').trim()
		},
		handleAvatarSuccess(res, file) {
			this.imageLoadding = false
			console.log(res)
			this.imageUrl = res.response
		},

		quillSuccess(response) {
			if (!response.success) {
				this.$message({
					message: response.msg,
					type: 'error',
				})
				return
			}
			const editorRef = this.$refs.myQuillEditor
			const editor = Array.isArray(editorRef) ? editorRef.find((e) => e && e.quill) : editorRef
			const quill = editor && editor.quill
			if (!quill) {
				this.$message.error('编辑器未就绪')
				return
			}
			const range = quill.getSelection()
			const pos = range ? range.index : quill.getLength()
			// 本机相对路径拼 API 前缀便于编辑器立即回显；入库前再收成相对路径
			const stablePath = stripOssPresignParams(response.response)
			quill.insertEmbed(pos, 'image', this.$resolveImageSrc(stablePath))
		},
		/** 富文本 Content 入库规范化。创建于 2026-09-22 */
		normalizeContentForSave(form) {
			if (!form || form.Content == null) return
			form.Content = normalizeRichTextHtmlForSave(form.Content, this.BaseApiUrl)
			if (!form.ValidFrom) form.ValidFrom = null
			if (!form.ValidTo) form.ValidTo = null
		},
		beforeAvatarUpload(file) {
			// 这里可以过滤不要的文件
			this.imageLoadding = true
			return true
		},
		//编辑
		editSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					if (!this.validateNoticeConfig(this.editForm)) {
						return
					}
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.editLoading = true
						//NProgress.start();
						this.editForm.imageUrl = this.imageUrl
						this.normalizeContentForSave(this.editForm)
						let para = Object.assign({}, this.editForm)
						editNoticeRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					if (!this.validateNoticeConfig(this.addForm)) {
						return
					}
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.addLoading = true
						//NProgress.start();
						this.addForm.imageUrl = this.imageUrl
						this.normalizeContentForSave(this.addForm)
						let para = Object.assign({}, this.addForm)
						var user = JSON.parse(window.localStorage.user)
						if (user && user.uID > 0) {
							para.CreateUser = user.uRealName
						} else {
							this.$message({
								message: '用户信息为空，先登录',
								type: 'error',
							})
							_this.$router.replace(
								_this.$route.query.redirect ? _this.$route.query.redirect : '/'
							)
						}

						addNoticeRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}

							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})

				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteNoticeRecord(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
	},
	watch: {
		'editForm.IsTextScroll'(val) {
			if (val) {
				this.editForm.Content = this.toPlainText(this.editForm.Content)
			}
		},
		'editForm.IsExternalLink'(val) {
			if (val == 1) {
				this.editForm.IsTextScroll = false
				this.editForm.Content = ''
			}
		},
		'addForm.IsTextScroll'(val) {
			if (val) {
				this.addForm.Content = this.toPlainText(this.addForm.Content)
			}
		},
		'addForm.IsExternalLink'(val) {
			if (val == 1) {
				this.addForm.IsTextScroll = false
				this.addForm.Content = ''
			}
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}

.field-tip {
	margin-left: 10px;
	font-size: 12px;
	color: #909399;
}
</style>

<style>
/* 公告弹窗表单样式（高度交给 dialog-theme / dialog-body-free，避免裁切 footer）。最后修改：2026-09-22 */
.notice-record-dialog .notice-form .el-form-item {
  margin-bottom: 14px;
}

.notice-record-dialog .notice-form .el-form-item__label {
  font-weight: 400;
  color: #475569;
}

.notice-form-section {
  padding: 12px 14px 2px;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 10px;
}

.notice-form-section--editor {
  padding-bottom: 12px;
}

.notice-form-section--editor .notice-form-section__title {
  margin-bottom: 8px;
}

.notice-editor-item {
  margin-bottom: 0 !important;
}

.notice-editor-item > .el-form-item__content {
  margin-left: 0 !important;
  line-height: 0;
}

.notice-editor-item .quill-editor,
.notice-editor-item .el-textarea {
  line-height: normal;
  font-size: 14px;
}

.notice-record-dialog .quill-editor .ql-container.ql-snow,
.notice-record-dialog .quill-editor .ql-editor {
  min-height: 280px;
}

.notice-form-section__title {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
  line-height: 1.4;
}

.notice-switch-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px 12px;
  margin-bottom: 4px;
}

.notice-switch-grid .el-form-item {
  margin-bottom: 8px;
}

.notice-switch-grid .el-form-item__content {
  line-height: 32px;
}

.notice-form-tip {
  margin: 0 0 10px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

.notice-form-tip--field {
  display: block;
  margin: 4px 0 0;
}

.notice-form-item--suffix .el-form-item__content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.notice-form-suffix {
  flex-shrink: 0;
  color: #64748b;
  font-size: 13px;
}

.notice-validity-row,
.notice-fullscreen-row {
  margin-top: 4px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;
}

@media (max-width: 768px) {
  .notice-switch-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
